import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Distrito } from 'src/app/models/Distrito';
import { Provincia } from 'src/app/models/Provincia';
import { Departamento } from 'src/app/models/Departamento';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { DistritoService } from 'src/app/services/distrito.service';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { Infobras } from 'src/app/models/Infobras';
import { InfobrasService } from 'src/app/services/infobras.service';
import { ModalIrregInfobrasComponent } from '../modal-irreg-infobras/modal-irreg-infobras.component';
import { openModalMensaje, DscTituloPaginator, DscHoraDefault,  isEmpty, ngClassAceptarModal, ngClassSalirModal, ngClassColorBtn3, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal, GetFecActualMaxCal, DscMensajeValFecha, ConvertDateTimeToStrForBD, strMatTablePaginator } from 'src/app/general/variables';
import { ObraPublica } from 'src/app/models/ObraPublica';
import { UbigeoProvisionalService } from 'src/app/services/ubigeoProvisional.service';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { FurXObraPublicaXHi } from 'src/app/models/FurXObraPublicaXHi';
import { FurXObraPublica } from 'src/app/models/FurXObraPublica';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { Entidad } from 'src/app/models/Entidad';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { InfobraConsulta } from 'src/app/models/personalizados/InfobraConsulta';
import { EjecucionInfobra } from 'src/app/models/EjecucionInfobra';
import { EventoInfobra } from 'src/app/models/EventoInfobra';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalidadInfobra } from 'src/app/models/ModalidadEjec';
import { ValidarFechaLength } from 'src/app/general/Funciones';

@Component({
  selector: 'app-modal-busq-obrpu',
  templateUrl: './modal-busq-obrpu.component.html',
  styleUrls: ['./modal-busq-obrpu.component.css']
})
export class ModalBusqObrpuComponent implements OnInit {
  // Icons
  iconAgregar = faPlus;
  // Errors
  claseError = '';
  flgListInfObras = false;
  // flgDeshabilitaBuscar = false;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  ngClassColorBtn3 = ngClassColorBtn3;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;

  matTableColumnsDef = ['item', 'codigo_infobras', 'descripcion_obra', 'costo', 'flgSeleccionar', 'Acciones'];
  matTableColumnsEtiq = ['Ítem', 'Código Infobras', 'Nombre de la Obra', 'Costo', 'Seleccionar', 'Irregularidad'];
  strMatTablePaginator = strMatTablePaginator;
  dataSource: MatTableDataSource<Infobras>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;


  /**GSOLIS
   *
   */
  select_tipejec: string = null;
  select_modalidad: string = null;
    select_departamento: string = null;
    select_provincia: string = null;
    select_distrito: string = null;
    select_entidades = ''; // Para las entidades
    input_entidad = '';
    input_nombreobra = '';
    input_codsnip = '';
    input_infobras = '';
    select_evento: string = null;
    select_anho: number;
    select_detevento = '';
    select_fase = '';
    select_monitoreo = '';
    input_montodesde: number;
    input_montohasta: number;

    nombreEntidad = '';
    strFechaIniFiltro: string ;
    strFechaFinFiltro: string;
    strFechaMaxCal: string;
    strDscValFecIni: string = null;
    strDscValFecFin: string = null;

   //
  // listTipoEjecucion : Catalogo[] = [];
  listTipoEjecucion: EjecucionInfobra[] = [];
  listModalidad: ModalidadInfobra[] = [];
  listEventos: EventoInfobra[] = [];
  listDistrito: Distrito[] = [];
  listProvincia: Provincia[] = [];
  listDepartamento: Departamento[] = [];
  listInfobras: Infobras[] = [];
  listInfobrasSel: Infobras[] = [];
  infobrasFiltro: InfobraConsulta = new InfobraConsulta(); // Infobras = new Infobras();
  flgMostrarAvanzada = false;
  tituloMensaje = 'Obras Públicas';

  obraPublicaHechoIrregular: FurXObraPublicaXHi;

  furObraPublica: FurXObraPublica = new FurXObraPublica();
  listEntidadesObras: Entidad[] = [];
  entidadObra: Entidad = new Entidad();
  obraPublica: ObraPublica = new ObraPublica();



  constructor( private dialogRef: MatDialogRef<ModalBusqObrpuComponent>,
               public mdModalIrreg: MatDialog,
               public dialog: MatDialog,
               protected catalogoService: CatalogoService,
               protected distritoService: DistritoService,
               protected provinciaService: ProvinciaService,
               protected departamentoService: DepartamentoService,
               protected infobrasService: InfobrasService,
               protected ubigeoProvisionalService: UbigeoProvisionalService,
               private maestraService: MaestrasService,
               private entidadService: EntidadService,
    // private externoService : ExternosService,
               private spinner: NgxSpinnerService,
               @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    const strCodDepart: string = this.data.codDepartEnt;
    const strCodProv: string = this.data.codProvEnt;
    const strCodDist: string = this.data.codDistEnt;

    this.strFechaMaxCal = GetFecActualMaxCal();

    this.navModalC.setDatosNavModal2('Búsqueda General de Obras Públicas');

    if (this.data.entidad != null && this.data.entidad != '') {

      this.select_entidades = this.data.entidad;

      this.entidadService.obtenerEntidadesXNombre( this.select_entidades).subscribe(data => {

        data = data.slice( 0, 20 );

        this.listEntidadesObras = data;

        this.llenarCombosEntidad(this.data.entidad);

      });



    }

    this.infobrasService.obtenerEjecucionObras().subscribe(data => {

      this.listTipoEjecucion = data;

    });

    this.infobrasService.obtenerModalidad().subscribe(data => {



      this.listModalidad = data;


      this.listModalidad.sort(function(a, b) {

        if (a.modalidad_ejecucion > b.modalidad_ejecucion) {
          return 1;
        }

        if (a.modalidad_ejecucion < b.modalidad_ejecucion) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

    });



    this.infobrasService.obtenerEventos().subscribe(data => {

      this.listEventos = data;

    });

    this.maestraService.obtenerDepartamentos().subscribe(data => {

      this.listDepartamento = data;



    });

    if (strCodDepart) {

      this.select_departamento = strCodDepart;

      this.cambiarDepartamento(strCodDepart);

      this.select_provincia = strCodProv;

      this.cambiarProvincia(strCodProv, strCodDepart);

      this.select_distrito = strCodDist;


    }


  }

  cambiarDepartamento(idDepartamento: string) {

    this.select_provincia = null;
    this.select_distrito = null;

    this.maestraService.obtenerProvincias(idDepartamento).subscribe(data => {
        this.listProvincia = data;

     });
  }

  cambiarProvincia(idProvincia: string, idDepartamento: string) {


    this.select_distrito = null;

    this.maestraService.obtenerDistritos(idDepartamento, idProvincia).subscribe(data => {
         this.listDistrito = data;
     });
  }

  CheckSeleccionar(infobrasSel: Infobras, data: any) {

    this.listInfobras.forEach(data1 => {

          if (data1.codigo_infobras == infobrasSel.codigo_infobras) {
            data1.flgSeleccionar = data.target.checked;

          } else {

            data1.flgSeleccionar = false;
          }
      });

  }

  ocultarBusqueda() {

    this.flgMostrarAvanzada = false;

  }

  _resetListado() {

    this.listInfobras = [];
    this.flgListInfObras = false;

    this._resetMatTable();

  }



  Buscar() {

    const departamento = this.select_departamento; // this.formBusqObraP.controls.select_departamento.value;
    const provincia = this.select_provincia; // this.formBusqObraP.controls.select_provincia.value;
    const distrito = this.select_distrito; // this.formBusqObraP.controls.select_distrito.value;
    let vFlgListInfobras = false;
    const vBusqEntidad = (document.getElementById('busqEntidad') as HTMLInputElement).value;
    let fechaIniFiltro: Date = new Date(this.strFechaIniFiltro);
    let fechaFinFiltro: Date = new Date(this.strFechaFinFiltro);
    let boolFlgFechaIniVacio: boolean = (this.strDscValFecIni == DscMensajeValFecha || this.strDscValFecIni == null);
    let boolFlgFechaFinVacio: boolean = (this.strDscValFecFin == DscMensajeValFecha || this.strDscValFecFin == null);
    let numCantFechaFiltro = 0;
    let boolFlgFiltrarFecha = false;
    const boolFlgFechaIniOK = !isNaN(Date.parse(this.strFechaIniFiltro));
    const boolFlgFechaFinOK = !isNaN(Date.parse(this.strFechaFinFiltro));

    if (boolFlgFechaIniOK) {

      boolFlgFechaIniVacio = false;

    }

    if (boolFlgFechaFinOK) {

      boolFlgFechaFinVacio = false;

    }

    if (!boolFlgFechaIniVacio) {

      // if(isNaN(Date.parse(this.strFechaIniFiltro)))
      if (boolFlgFechaIniOK == false) {

        openModalMensaje('Formulario Virtual', 'La fecha inicial no es válida, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        });

        return;

      }

      numCantFechaFiltro++;


    }

    if (!boolFlgFechaFinVacio) {

      // if(isNaN(Date.parse(this.strFechaFinFiltro)))
      if (boolFlgFechaFinOK == false) {

        openModalMensaje('Formulario Virtual', 'La fecha final no es válida, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        });

        return;

      }

      numCantFechaFiltro++;


    }

    if (!boolFlgFechaIniVacio && boolFlgFechaFinVacio) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar la fecha final, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

      });

      return;


    }

    if (numCantFechaFiltro == 2) {

      fechaIniFiltro.setDate(fechaIniFiltro.getDate() + 1);
      fechaFinFiltro.setDate(fechaFinFiltro.getDate() + 1);

      fechaIniFiltro = new Date(fechaIniFiltro.getFullYear(), fechaIniFiltro.getMonth(), fechaIniFiltro.getDate());
      fechaFinFiltro = new Date(fechaFinFiltro.getFullYear(), fechaFinFiltro.getMonth(), fechaFinFiltro.getDate());

      if (fechaIniFiltro > fechaFinFiltro) {

        openModalMensaje('Formulario Virtual', 'La fecha inicial no debe ser mayor al final, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        });

        return;

      }

      boolFlgFiltrarFecha = true;

    }

    this._resetListado();

    if ( departamento == null || provincia == null || distrito == null ||  departamento.length == 0 || provincia.length == 0 || distrito.length == 0) {

      openModalMensaje(this.tituloMensaje, 'Debe seleccionar el departamento,provincia y distrito, por favor verifique', this.dialog);

      return;

    } else if (this.entidadObra == null || this.entidadObra.centCodigo == null || isEmpty(vBusqEntidad)) {

      openModalMensaje(this.tituloMensaje, 'Debe Ingresar la entidad', this.dialog);

      return;
    } else if (isEmpty(this.select_modalidad)) {

      openModalMensaje(this.tituloMensaje, 'Debe Ingresar la modalidad de ejecución', this.dialog);

      return;
    }



    this.infobrasFiltro = new InfobraConsulta();

    this.infobrasFiltro.cod_departamento = this.select_departamento;
    this.infobrasFiltro.cod_distrito = this.select_distrito;
    this.infobrasFiltro.cod_provincia = this.select_provincia;
    this.infobrasFiltro.entidad = this.nombreEntidad;

    this.infobrasFiltro.modalidad_ejecucion = this.select_modalidad;
    this.infobrasFiltro.monitor = this.select_modalidad;

    if (boolFlgFiltrarFecha == true) {

      this.infobrasFiltro.fecha_de_inicio = ConvertDateTimeToStrForBD(fechaIniFiltro, false);
      this.infobrasFiltro.fecha_de_fin = ConvertDateTimeToStrForBD(fechaFinFiltro, false);

    }


    if (this.flgMostrarAvanzada) {

      this.infobrasFiltro.descripcion_obra = this.input_nombreobra; // this.formBusqObraP.controls.input_nombreobra.value;
      this.infobrasFiltro.codigo_snip = this.input_codsnip; // this.formBusqObraP.controls.input_codsnip.value;
      this.infobrasFiltro.codigo_infobras = this.input_infobras; // this.formBusqObraP.controls.input_infobras.value;
      this.infobrasFiltro.evento = this.select_evento; // this.formBusqObraP.controls.select_evento.value;


    }

  // console.log("=================this.infobrasFiltro");
  // console.log(JSON.stringify(this.infobrasFiltro) );

    this.spinner.show();

    this.infobrasService.listarInfobras(this.infobrasFiltro).subscribe(

    data => {

      this.spinner.hide();


      if (data != null) {

        if (data.length > 0) {

          let fechaInicio = '';

          const tamanio = data.length;

          for (let index = 0; index < tamanio; index ++ ) {

            this.listInfobras[index] = new Infobras();

            fechaInicio = data[index].fecha_de_inicio;

            this.listInfobras[index].num_item = index + 1;
            this.listInfobras[index].num_index = index;
            this.listInfobras[index].entidad = data[index].entidad;
            this.listInfobras[index].provincia = data[index].cod_provincia;
            this.listInfobras[index].departamento = data[index].cod_departamento;
            this.listInfobras[index].distrito = data[index].cod_distrito;
            this.listInfobras[index].codigo_snip = data[index].codigo_snip;
            this.listInfobras[index].fecha_de_fin = data[index].fecha_de_fin;
            this.listInfobras[index].fecha_de_inicio = data[index].fecha_de_inicio;
            this.listInfobras[index].catalogo_nivel_1 = data[index].catalogo_nivel_1;
            this.listInfobras[index].codigo_entidad = data[index].codigo_entidad;
            this.listInfobras[index].codigo_infobras = data[index].codigo_infobras;
            this.listInfobras[index].descripcion_obra = data[index].descripcion_obra;
            this.listInfobras[index].estado_de_ejecucion = data[index].estado_de_ejecucion;
            this.listInfobras[index].fecha_registro = data[index].fecha_registro;
            this.listInfobras[index].plazo_de_ejecucion = data[index].plazo_de_ejecucion;
            // this.listInfobras[index].costo = data[index].costo;
            this.listInfobras[index].costo = data[index].monto_expediente;

            // this.listInfobras[index].Anho = Number(fechaInicio.substr(0,4));
            this.listInfobras[index].flgSeleccionar = false;

          }

          // this.flgListInfObras = true;
          vFlgListInfobras = true;

        } else {
          openModalMensaje(this.tituloMensaje, 'No se encuentran registros con los parámetros de búsqueda,verifique por favor', this.dialog);
          // this.flgListInfObras = false;
          vFlgListInfobras = false;
        }

      } else {
        openModalMensaje(this.tituloMensaje, 'No se encuentran registros con los parámetros de búsqueda,verifique por favor', this.dialog);
        // this.flgListInfObras = false;
        vFlgListInfobras = false;

      }


      this.flgListInfObras = vFlgListInfobras;

      this._resetMatTable();

    },
    err => {

      this.spinner.hide();

      console.log(err);

    });

  }

  // _cambioFechaIni()
  // {
  //   this.strFechaIniFiltro = ValidarFechaLength(this.strFechaIniFiltro);

  // }

  _KUcambiofechaIni(valor) {

    this.strDscValFecIni = valor.target.validationMessage;

    this.strFechaIniFiltro = valor.target.value;

  }

  _KUcambiofechaFin(valor) {

    this.strDscValFecFin = valor.target.validationMessage;

    this.strFechaFinFiltro = valor.target.value;

  }

  // _cambioFechaFin()
  // {

  //   this.strFechaFinFiltro = ValidarFechaLength(this.strFechaFinFiltro);

  // }

  _resetMatTable() {

    if (this.flgListInfObras) {

      setTimeout(() => {

        this.dataSource = new MatTableDataSource(this.listInfobras);

        if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

        // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      }, 1);

    }



  }

  BusquedaAvanzada() {

    // this.input_nombreobra = null;//this.formBusqObraP.controls.input_nombreobra.value;
    // this.input_codsnip = null;//this.formBusqObraP.controls.input_codsnip.value;
    // this.input_infobras = null;//this.formBusqObraP.controls.input_infobras.value;
    // this.select_evento = null;//this.formBusqObraP.controls.select_evento.value;

    this.flgMostrarAvanzada = true;

    // console.log("BUSQUEDAD AVANZADA");

  }

  AgregarIrregularidad(codInfobras: string, flgSeleccionar: boolean, obra: Infobras) {

    const obraPublica = new ObraPublica();
    let vFchFin = null;
    let vFchIni = null;

    // console.log(obra);
    if (!obra.flgSeleccionar) {
      openModalMensaje(this.tituloMensaje, 'Primero seleccione la obra pública', this.dialog);
      return;
    }

    vFchFin = obra.fecha_de_fin;
    vFchIni = obra.fecha_de_inicio;


    // console.log("=================obra");
    // console.log(obra);

    obraPublica.cobrapublicaCodinfob = obra.codigo_infobras;
    obraPublica.cobrapublicaDscnombre = obra.descripcion_obra;
    obraPublica.nobrapublicaCosto = obra.costo;
    obraPublica.cobrapublicaCdepent = obra.departamento;
    obraPublica.cobrapublicaCdistent = obra.distrito;
    obraPublica.cobrapublicaCprovent = obra.provincia;
    obraPublica.nobrapublicaAnho = obra.Anho;
    obraPublica.cobrapublicaDscestado = obra.estado_de_ejecucion;
    obraPublica.strDobrapublicaFechaini = (vFchIni == null ? '' : obra.fecha_de_inicio + DscHoraDefault);
    obraPublica.strDobrapublicaFechafin = (vFchFin == null ? '' : obra.fecha_de_fin + DscHoraDefault);
    // Servicio Infoobra
    // obraPublica.cobrapublicaEstado = 'En ejecución';
    // obraPublica.dobrapublicaFechaIni = '13-06-2019';
    // obraPublica.dobrapublicaFechaFin = '12-12-2020';
    // obraPublica.nobrapublicaIddeteven = obra.Evento;
    this.furObraPublica.obraPublica = obraPublica;

    /*this.listInfobras.forEach(data=>{
      if(data.codigo_infobras == codInfobras){
          let obraPublica = new ObraPublica();
          obraPublica.cobrapublicaCodinfob = data.codigo_infobras;
          obraPublica.cobrapublicaDscnombre = data.descripcion_obra;
          obraPublica.nobrapublicaCosto = data.costo;
          obraPublica.cobrapublicaCdepent = data.departamento;
          obraPublica.cobrapublicaCdistent = data.distrito;
          obraPublica.cobrapublicaCprovent = data.provincia;
          obraPublica.nobrapublicaAnho = data.Anho;
          obraPublica.nobrapublicaIddeteven = data.Evento;
          console.log(obraPublica);
          this.furObraPublica.obraPublica = obraPublica;

      }
    });*/

    const dialogRef = this.mdModalIrreg.open(ModalIrregInfobrasComponent, { width: '80%', height: '87%', data: {obraPub : this.furObraPublica}});

    dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          this.furObraPublica = result;
        }

        // console.log(this.furObraPublica);

    });

    // Falta la homologaci+on de datos con this.obraPublica

  }

  aceptar() {

    const flgVacio = 0;
    // if(this.obraPublica.cobrapublicaCodinfob.length == 0 || this.obraPublica.listHechoIrregular.length == 0)

    if (this.furObraPublica.obraPublica == null || this.furObraPublica.listaFurPorObraPubPorHechoIrr == null || this.furObraPublica.listaFurPorObraPubPorHechoIrr.length == 0) {
      openModalMensaje(this.tituloMensaje, 'Debe seleccionar la obra pública y los hechos irregulares, por favor verifique', this.dialog);
    } else {
      this.dialogRef.close(this.furObraPublica);
    }



   /*this.listInfobras.forEach(obra=>{
        if(obra.flgSeleccionar){
          console.log(obra);
          if(obra.listHechoIrregular.length==0){
            flgVacio = 1;
          }else{
            this.listInfobrasSel.push(obra);
          }

        }

     });
     if(this.listInfobrasSel.length==0){
      flgVacio = 1;
    }

    if(flgVacio==1){
      openModalMensaje(this.tituloMensaje,"Debe seleccionar la obra pública y los hechos irregulares, por favor verifique",this.dialog);
     }else{

      this.dialogRef.close(this.listInfobrasSel);
     }*/

    // this.dialogRef.close(this.obraPublica);


    // var numFlgSeleccionar = 0;

    // for (let index = 0; index < this.listInfobras.length; index++)
    // {

    //   if(this.listInfobras[index].flgSeleccionar)
    //   {

    //     numFlgSeleccionar = 1;

    //   }

    // }

    // if(numFlgSeleccionar == 0)
    // {
    // }

  }

  cancelar() {
    this.dialogRef.close();
  }


  buscarEntidad(valor) {
    const nombreEntidad = valor.target.value;

    this.nombreEntidad = nombreEntidad;

    // console.log("============nombreEntidad");
    // console.log(nombreEntidad);

    if (nombreEntidad.length > 4) {

      this.entidadService.obtenerEntidadesXNombre(nombreEntidad).subscribe(data => {

          data = data.slice( 0, 20 );

          this.listEntidadesObras = data;

          if (this.listEntidadesObras.length == 1) {

            // this.obtenerEntidad(this.entidades[0].centCodigo);

            this.llenarCombosEntidad(this.listEntidadesObras[0].centNombre);

          }

          // console.log("======this.listEntidadesObras");
          // console.log(this.listEntidadesObras);


      });

    }
  }

  seleccionarEntidad(strEntidad) {

    // let name = event.target.value;
    const name = strEntidad;

    // console.log("name",name);

    this.llenarCombosEntidad(name);

    this.listEntidadesObras = [];

  }

  llenarCombosEntidad(nombreEntidad: string) {


    let list = null;

    if (this.listEntidadesObras == null) {return; }

    list = this.listEntidadesObras.filter(x => x.centNombre === nombreEntidad)[0];
    // console.log("ESTA ES LA LISTA");
    // console.log(list);
    if (list != null) {
      this.nombreEntidad = list.centNombre;
      this.entidadService.obtenerEntidadXCodigo(list.centCodigo).subscribe(data => {

        if (data != null) {
          this.entidadObra = data;
        }

    });
    }

  }

}
